export const LICENSE_FEATURE_KEY = 'license';
